import { render, staticRenderFns } from "./Friends.vue?vue&type=template&id=8b8cf552&scoped=true"
import script from "./Friends.vue?vue&type=script&lang=js"
export * from "./Friends.vue?vue&type=script&lang=js"
import style0 from "./Friends.vue?vue&type=style&index=0&id=8b8cf552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8cf552",
  null
  
)

export default component.exports